<template>
  <div class="wrapper">

    <!-- new header goes here -->
    <new-app-header></new-app-header>

    <!-- new carousel goes here -->
    <new-app-carousel></new-app-carousel>

    <!-- notices goes here -->
    <app-notice></app-notice>

    <!-- New Content -->
    <app-content></app-content>

     <!-- new footer -->
    <new-app-footer></new-app-footer>

    <!-- old header -->
    <!-- <app-header></app-header> -->

<!-- 
    <div class="banner-image">
        <carousel :margin="20" autoHeight :items="1" :autoplay="true" :autoplaySpeed="true" loop center :nav=false>
            <div class="im"><img src="../../assets/png/sliderOnMain/1.jpg" /></div>
            <div class="im"><img src="../../assets/png/sliderOnMain/2.jpg" /></div>
            <div class="im"><img src="../../assets/png/sliderOnMain/3.jpg" /></div>
            <div class="im"><img src="../../assets/png/sliderOnMain/4.jpg" /></div>
            <div class="im"><img src="../../assets/png/sliderOnMain/6.jpg" /></div>
            <div class="im"><img src="../../assets/png/sliderOnMain/7.jpg" /></div>
        </carousel>
    </div> -->

    <!-- <app-short-info></app-short-info>
    <app-articles></app-articles>
    <app-events :isMain = 'true'></app-events>
    <app-contact></app-contact>
    <app-footer></app-footer> -->

  </div>
</template>

<script>
// import Header from '@/components/layout/Header';
// import Footer from '@/components/layout/Footer';
// import ShortInfo from './ShortInfo';
// import ContactUs from '@/components/ui/ContactUs';
import NewHeader from '@/components/layout/NewHeader';
import NewFooter from '@/components/layout/NewFooter';
import NewCarousel from '@/components/layout/NewCarousel';
import Content from './Content';
import Notice from './Notices';

// import Events from './Events/Events';
// import Articles from './Articles';

//import carousel from 'vue-owl-carousel'

export default {
  components: {
    // 'app-header': Header,
    // 'app-footer': Footer,
    // 'app-short-info': ShortInfo,
    // 'app-contact': ContactUs,
    // 'app-events': Events,

    'new-app-header': NewHeader,
    'new-app-footer': NewFooter,
    'new-app-carousel': NewCarousel,
    'app-content': Content,
    'app-notice' : Notice,
  },
  data(){
    return {
    }
  },
  
}
</script>

<style lang="scss" scoped>
.wrapper {
  width:100%;
  max-width: 1920px;
}
.im {
    display: flex;
    align-items: center;
    width: 100%;
    max-height: 756px;
    object-fit: cover;
}
  .banner-image {
      /*height: 756px;*/
      padding: 40px 20px 0;

  }
</style>
